import AssetViewService from '@/general/services/overview-service/modules/media/asset-view.service';
import { InjectionKey } from 'vue';

export const assetViewServiceKey = Symbol() as InjectionKey<AssetViewService>;
